import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-green text-white hover:bg-green-hover shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    secondary: 'bg-navy text-white hover:bg-opacity-90 shadow-md',
    outline: 'border-2 border-navy text-navy hover:bg-navy/5'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <motion.button ref={ref} whileTap={{
    scale: 0.98
  }} className={twMerge(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-162" />;
});
Button.displayName = 'Button';